export default __webpack_public_path__ + "static/media/trash.f95c3157.svg";